import * as yup from 'yup';
import {parse, isDate} from "date-fns";
import { validateYupSchema } from 'formik';

export default class FormConfig {
  static parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue)
      ? originalValue
      : parse(originalValue, "yyyy-MM-dd", new Date());
  
    return parsedDate;
  }
  static CreateAccountForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Account Number',
      backendName: 'AccountNumber',
      type: 'string',
      placeholder: "Enter Account Number",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Is Child Account',
      backendName: 'IsChildAccount',
      type: 'bool',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Account Name',
      backendName: 'AccountName',
      type: 'string',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required().test('len', 'Must be less than 255 characters', val => { return val?.length < 255 || val === null })
    },
    {
      displayName: 'Quickbooks ID',
      backendName: 'QuickbooksID',
      type: 'string',
      placeholder: "Enter Quickbooks ID",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true;
        return val.length < 255;
      })
    },
    {
      displayName: 'Past Due Warning',
      backendName: 'PastDueWarning',
      type: 'number',
      placeholder: "Enter Past Due Warning",
      required: false,
      isEditable: true,
      validationFunction: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === "" || originalValue === null || originalValue === undefined
            ? null
            : value
        )
        .nullable()
        .typeError("Past Due Warning must be a valid number")
        .min(0, "Past Due Warning must be greater than or equal to 0"),
    },
    {
      displayName: 'Past Due Limit',
      backendName: 'PastDueLimit',
      type: 'number',
      placeholder: "Enter Past Due Limit",
      required: false,
      isEditable: true,
      validationFunction: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === "" || originalValue === null || originalValue === undefined
            ? null
            : value
        )
        .nullable()
        .typeError("Past Due Limit must be a valid number")
        .min(0, "Past Due Limit must be greater than or equal to 0"),
    },
    {
      displayName: 'Billing Account',
      backendName: 'BillingAccountID',
      type: 'option',
      placeholder: "Select Billing Account",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Billing Account Name',
      backendName: 'BillingAccountName',
      type: 'option',
      placeholder: "Select Billing Account",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Account Type',
      backendName: 'AccountType',
      type: 'string',
      placeholder: "Enter Account Type",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      required: true,
      isEditable: true
    },
    {
      displayName: 'Region',
      backendName: 'RegionID',
      type: 'option',
      placeholder: "Select Region",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Region',
      backendName: 'RegionName',
      type: 'option',
      placeholder: "Select Region",
      required: true,
      isEditable: true
    },
    // Distributor
    // Billing Account (different account)
    {
      displayName: 'Address Line 1',
      backendName: 'AddressLine1',
      type: 'string',
      placeholder: "Enter Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required().test('len', 'Must be less than 255 characters', val => { return val?.length < 255 || val === null })
    },
    {
      displayName: 'Address Line 2',
      backendName: 'AddressLine2',
      type: 'string',
      placeholder: "Enter Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'City',
      backendName: 'City',
      type: 'string',
      placeholder: "Enter City",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'State',
      backendName: 'State',
      type: 'string',
      placeholder: "Enter State",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'ZIP',
      backendName: 'Zip',
      type: 'string',
      placeholder: "Enter ZIP",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Billing Address Line 1',
      backendName: 'BillingAddressLine1',
      type: 'string',
      placeholder: "Enter Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'BllingAddress Line 2',
      backendName: 'BillingAddressLine2',
      type: 'string',
      placeholder: "Enter Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Billing City',
      backendName: 'BillingCity',
      type: 'string',
      placeholder: "Enter City",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Billing State',
      backendName: 'BillingState',
      type: 'string',
      placeholder: "Enter State",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Billing ZIP',
      backendName: 'BillingZip',
      type: 'string',
      placeholder: "Enter ZIP",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      type: 'string',
      placeholder: "Enter Phone",
      required: true,
      isEditable: true,
      // validationFunction: yup.string().required().matches(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Please enter a valid phone number')
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Fax',
      backendName: 'Fax',
      type: 'string',
      placeholder: "Enter Fax",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    // Region => Comes from region table
    {
      displayName: 'Region',
      backendName: 'RegionID',
      type: 'option',
      placeholder: "Select Region",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("Region is required")
    },
    {
      displayName: 'APContact',
      backendName: 'APContact',
      type: 'string',
      placeholder: "Enter APContact",
      required: true,
      isEditable: true
    },
    {
      displayName: 'MedicareAdminContractor',
      backendName: 'MedicareAdminContractor',
      type: 'string',
      placeholder: "Enter MedicareAdminContractor",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'NPI',
      backendName: 'NPI',
      type: 'string',
      placeholder: "Enter NPI",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'TIN',
      backendName: 'TIN',
      type: 'string',
      placeholder: "Enter TIN",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'PTAN',
      backendName: 'PTAN',
      type: 'string',
      placeholder: "Enter PTAN",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'EIN',
      backendName: 'EIN',
      type: 'string',
      placeholder: "Enter EIN",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'BAA',
      backendName: 'BAA',
      type: 'bool',
      placeholder: "Enter BAA",
      required: true,
      isEditable: true
    },
    {
      displayName: 'EnableIVR',
      backendName: 'EnableIVR',
      type: 'bool',
      placeholder: "EnableIVR",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Account BAA File',
      backendName: 'AccountBAAFileName',
      type: 'string',
    },
    {
      displayName: 'Account BAA File Blob Name',
      backendName: 'AccountBAAAzureBlobName',
      type: 'string',
    },
    {
      displayName: 'ParentAccountID',
      backendName: 'ParentAccountID',
      type: 'option',
      placeholder: "Select Parent Account",
      required: true,
      isEditable: true
    }

  ]
  
  static CreateDistributorForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Distributor Name',
      backendName: 'DistributorName',
      type: 'string',
      placeholder: "Enter Distributor Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Distributor Number',
      backendName: 'DistributorNumber',
      type: 'string',
      placeholder: "Enter Distributor Number",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'AddressLine1',
      type: 'string',
      placeholder: "Enter Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Address Line 2',
      backendName: 'AddressLine2',
      type: 'string',
      placeholder: "Enter Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'City',
      backendName: 'City',
      type: 'string',
      placeholder: "Enter City",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'State',
      backendName: 'State',
      type: 'string',
      placeholder: "Enter State",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'ZIP',
      backendName: 'Zip',
      type: 'string',
      placeholder: "Enter ZIP",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      type: 'string',
      placeholder: "Enter Phone",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Fax',
      backendName: 'Fax',
      type: 'string',
      placeholder: "Enter Fax",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Enable Commissions',
      backendName: 'EnableCommissionModule',
      type: 'boolean',
      placeholder: "Enable Commission Module",
      required: true,
      isEditable: true,
      validationFunction: yup.boolean(),
      defaultValue: true
    }
  ]

  static CreateManufacturerForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Manufacturer Name',
      backendName: 'ManufacturerName',
      type: 'string',
      placeholder: "Enter Manufacturer Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Manufacturer Number',
      backendName: 'ManufacturerNumber',
      type: 'string',
      placeholder: "Enter Manufacturer Number",
      required: true,
      isEditable: true,
      validationFunction:yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Manufacturer Abbreviation',
      backendName: 'ManufacturerAbbreviation',
      type: 'string',
      placeholder: "Enter Manufacturer Abbreviation",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Address Line 1',
      backendName: 'AddressLine1',
      type: 'string',
      placeholder: "Enter Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Address Line 2',
      backendName: 'AddressLine2',
      type: 'string',
      placeholder: "Enter Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'City',
      backendName: 'City',
      type: 'string',
      placeholder: "Enter City",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'State',
      backendName: 'State',
      type: 'string',
      placeholder: "Enter State",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'ZIP',
      backendName: 'Zip',
      type: 'string',
      placeholder: "Enter ZIP",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Direct Order Email',
      backendName: 'ManufacturerEmailDO',
      type: 'string',
      placeholder: "Enter Direct Order Email",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Consignment Order Email',
      backendName: 'ManufacturerEmailCO',
      type: 'string',
      placeholder: "Enter Consignment Order Email",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Product Usage Email',
      backendName: 'ManufacturerEmailPU',
      type: 'string',
      placeholder: "Enter Product Usage Email",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      type: 'string',
      placeholder: "Enter Phone",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Fax',
      backendName: 'Fax',
      type: 'string',
      placeholder: "Enter Fax",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Needs Approval',
      backendName: 'NeedsApproval',
      type: 'checkbox',
      placeholder: "",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Collect Payment',
      backendName: 'CollectPayment',
      type: 'checkbox',
      placeholder: "",
      required: false,
      isEditable: true
    },
    {
      displayName: 'Manufacturer Visibility',
      backendName: 'ManufacturerVisibility',
      type: 'checkbox',
      placeholder: "",
      required: true,
      isEditable: true
    },
    {
      displayName: 'Manufacturer Visibility',
      backendName: 'ManufacturerVisibilityDO',
      type: '',
      placeholder: "",
      required: false,
      isEditable: true
    },
    {
      displayName: 'Manufacturer Visibility',
      backendName: 'ManufacturerVisibilityCO',
      type: '',
      placeholder: "",
      required: false,
      isEditable: true
    },
    {
      displayName: 'Manufacturer Visibility',
      backendName: 'ManufacturerVisibilityPU',
      type: '',
      placeholder: "",
      required: false,
      isEditable: true
    },
  ]
  static CreateProductUsageForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountName',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUserID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUsername',
      validationFunction: ""
    },
    {
      displayName: 'Status',
      backendName: 'Status',
      type: 'option',
      placeholder: "Enter Status",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedBy',
      backendName: 'OrderPlacedBy',
      type: 'string',
      placeholder: "Enter OrderPlacedBy",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedByEmail',
      backendName: 'OrderPlacedByEmail',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderType',
      backendName: 'OrderType',
      type: 'string',
      placeholder: "Enter Order Type",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderDate',
      backendName: 'OrderDate',
      type: 'date',
      placeholder: "Enter OrderDate",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Requested Delivery Date',
      backendName: 'RequestedDeliveryDate',
      type: 'date',
      placeholder: "Enter Requested Delivery Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Shipping Preference',
      backendName: 'ShippingPreference',
      type: 'option',
      placeholder: "Select Shipping Preference",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required()
    },
    {
      displayName: 'PO Number',
      backendName: 'PONumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountID',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountName',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactName',
      type: 'string',
      placeholder: "Enter Ship to Contact Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactID',
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'ShipAddressLine1',
      type: 'string',
      placeholder: "Enter Ship to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'ShipAddressLine2',
      type: 'string',
      placeholder: "Enter Ship to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'ShipCity',
      type: 'string',
      placeholder: "Enter Ship to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'ShipState',
      type: 'string',
      placeholder: "Enter Ship to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'ShipZip',
      type: 'string',
      placeholder: "Enter Ship to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'ShipPhone',
      type: 'string',
      placeholder: "Enter Ship to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'ShipFax',
      type: 'string',
      placeholder: "Enter Ship to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountID',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountName',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Contact Name',
      backendName: 'BillToContactName',
      type: 'string',
      placeholder: "Enter Bill to Contact Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContact',
      type: 'string',
      placeholder: "Enter Accounts Payable Contact",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContactID',
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'BillAddressLine1',
      type: 'string',
      placeholder: "Enter Bill to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'BillAddressLine2',
      type: 'string',
      placeholder: "Enter Bill to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'BillCity',
      type: 'string',
      placeholder: "Enter Bill to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'BillState',
      type: 'string',
      placeholder: "Enter Bill to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'BillZip',
      type: 'string',
      placeholder: "Enter Bill to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'BillPhone',
      type: 'string',
      placeholder: "Enter Bill to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'BillFax',
      type: 'string',
      placeholder: "Enter Bill to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Physician Name',
      backendName: 'PhysicianName',
      type: 'string',
      placeholder: "Enter Physician Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("Please enter Physician Name")
    },
    {
      displayName: 'Patient First Name',
      backendName: 'PatientFirstName',
      type: 'string',
      placeholder: "Enter Physician First Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().min(1, "Please enter Patient First Name").max(3, 'Please enter first three letters only').required("Please enter first three letters only"),
      // validateSchema: ""
    },
    {
      displayName: 'Patient Last Name',
      backendName: 'PatientLastName',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: yup.string().min(1, "Please enter Patient Last Name").max(3, 'Please enter first three letters only').required("Please enter first three letters only"),
      // validateSchema: ""
    },
    {
      displayName: 'CaseID',
      backendName: 'Patient Last Name',
      type: 'string',
      placeholder: "Enter Case ID",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Date Of Application',
      backendName: 'DateOfApplication',
      type: 'date',
      placeholder: "Date Of Application",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Application Number',
      backendName: 'ApplicationNumber',
      type: 'string',
      placeholder: "Enter Application Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("Please enter Application Number")
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerID',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerName',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Number Of Products',
      backendName: 'NumberOfProducts',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Order Total',
      backendName: 'OrderTotal',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Tracking Number',
      backendName: 'TrackingNumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved By',
      backendName: 'ApprovedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved Date',
      backendName: 'ApprovedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected By',
      backendName: 'RejectedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected Date',
      backendName: 'RejectedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Reject Remarks',
      backendName: 'RejectRemarks',
      validationFunction: ""
    },
    {
      displayName: 'File Upload',
      backendName: 'UploadedFile',
      type: 'file',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    }
  ]
  static InvoiceForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'PO Number',
      backendName: 'PONumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Order Type",
      backendName: "OrderType",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: false,
    },
    {
      displayName: 'Invoice Number',
      backendName: 'InvoiceNumber',
      type: 'string',
      placeholder: "Enter Invoice Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field")
    },
    {
      displayName: 'Shipping Cost',
      backendName: 'ShippingCost',
      validationFunction: ""
    },
    {
      displayName: 'Invoice Date',
      backendName: 'InvoiceDate',
      type: 'date',
      placeholder: "Enter Invoice Date",
      required: true,
      isEditable: true,
      validationFunction: yup.date().required("This is a required field")
    },
    {
      displayName: 'Invoice Due Date',
      backendName: 'InvoiceDueDate',
      type: 'date',
      placeholder: "Enter Invoice Due Date",
      required: true,
      isEditable: true,
      validationFunction: yup.date().required("This is a required field")
    },
    {
      displayName: 'Invoice Total',
      backendName: 'InvoiceTotal',
      type: 'number',
      placeholder: "Enter Invoice Total",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "UploadInvoiceFileName",
      backendName: "UploadInvoiceFileName",
    },
    {
      displayName: "UploadInvoiceFileBlobName",
      backendName: "UploadInvoiceFileBlobName",
    },
  ]
  static InvoiceHomeForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Invoice Number',
      backendName: 'InvoiceNumber',
      type: 'string',
      placeholder: "Enter Invoice Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'PO Number',
      backendName: 'PONumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fully Paid Date',
      backendName: 'FullyPaidDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Invoice Date',
      backendName: 'InvoiceDate',
      type: 'date',
      placeholder: "Enter Invoice Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Invoice Due Date',
      backendName: 'InvoiceDueDate',
      type: 'date',
      placeholder: "Enter Invoice Due Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Invoice in Appeal',
      backendName: 'InvoiceInAppeal',
      type: 'string',
      placeholder: "Enter Invoice in Appeal",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Invoice Total',
      backendName: 'InvoiceTotal',
      type: 'number',
      placeholder: "Enter Invoice Total",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Shipping Cost",
      backendName: "ShippingCost",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
    },
    // {
    //   displayName: "Paid",
    //   backendName: "IsShippingCostPaid",
    // },
    {
      displayName: "Distributor",
      backendName: "DistributorID",
      validationFunction: ""
    },
    {
      displayName: "Distributor",
      backendName: "DistributorName",
      validationFunction: ""
    },
    {
      displayName: "Total Payments Applied",
      backendName: "TotalPaymentsApplied",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
    },
    {
      displayName: "Shipping Cost Assigned To",
      backendName: "ShippingCostAssignedTo",
      type: "option",
      placeholder: "",
      required: true,
      isEditable: true,
    },
    {
      displayName: "Is Voided",
      backendName: "IsVoided",
      type: "bool",
      placeholder: "",
      required: true,
      isEditable: true,
    },
  ]
  static CreateConsignmentOrderForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Status',
      backendName: 'Status',
      type: 'option',
      placeholder: "Enter Status",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountName',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedBy',
      backendName: 'OrderPlacedBy',
      type: 'string',
      placeholder: "Enter OrderPlacedBy",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'PO Number',
      backendName: 'PONumber',
      type: 'string',
      placeholder: "Enter PO Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUserID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUsername',
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedBy',
      backendName: 'OrderPlacedBy',
      type: 'string',
      placeholder: "Enter OrderPlacedBy",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedByEmail',
      backendName: 'OrderPlacedByEmail',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderType',
      backendName: 'OrderType',
      type: 'string',
      placeholder: "Enter Order Type",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderDate',
      backendName: 'OrderDate',
      type: 'string',
      placeholder: "Enter OrderDate",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Requested Delivery Date',
      backendName: 'RequestedDeliveryDate',
      type: 'date',
      placeholder: "Enter Requested Delivery Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Shipping Preference',
      backendName: 'ShippingPreference',
      type: 'option',
      placeholder: "Select Shipping Preference",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required()
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountID',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountName',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactName',
      type: 'string',
      placeholder: "Enter Ship to Contact Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactID',
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'ShipAddressLine1',
      type: 'string',
      placeholder: "Enter Ship to Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'ShipAddressLine2',
      type: 'string',
      placeholder: "Enter Ship to Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'ShipCity',
      type: 'string',
      placeholder: "Enter Ship to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'ShipState',
      type: 'string',
      placeholder: "Enter Ship to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'ShipZip',
      type: 'string',
      placeholder: "Enter Ship to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'ShipPhone',
      type: 'string',
      placeholder: "Enter Ship to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'ShipFax',
      type: 'string',
      placeholder: "Enter Ship to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""  
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountID',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountName',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContact',
      type: 'string',
      placeholder: "Enter Accounts Payable Contact",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContactID',
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'BillAddressLine1',
      type: 'string',
      placeholder: "Enter Bill to Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'BillAddressLine2',
      type: 'string',
      placeholder: "Enter Bill to Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'BillCity',
      type: 'string',
      placeholder: "Enter Bill to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'BillState',
      type: 'string',
      placeholder: "Enter Bill to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'BillZip',
      type: 'string',
      placeholder: "Enter Bill to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'BillPhone',
      type: 'string',
      placeholder: "Enter Bill to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'BillFax',
      type: 'string',
      placeholder: "Enter Bill to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerID',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerName',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Number Of Products',
      backendName: 'NumberOfProducts',
      type: 'number',
      placeholder: "Enter Number Of Products",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Order Total',
      backendName: 'OrderTotal',
      type: 'number',
      placeholder: "Enter Order Total",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Tracking Number',
      backendName: 'TrackingNumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved By',
      backendName: 'ApprovedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved Date',
      backendName: 'ApprovedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected By',
      backendName: 'RejectedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected Date',
      backendName: 'RejectedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Reject Remarks',
      backendName: 'RejectRemarks',
      validationFunction: ""
    },
  ]
  static CreateDirectOrderForm = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountName',
      type: 'option',
      placeholder: "Enter Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      type: 'option',
      placeholder: "Select Distributor",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUserID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUsername',
      validationFunction: ""
    },
    {
      displayName: 'Status',
      backendName: 'Status',
      type: 'string',
      placeholder: "Enter Status",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedBy',
      backendName: 'OrderPlacedBy',
      type: 'string',
      placeholder: "Enter OrderPlacedBy",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderPlacedByEmail',
      backendName: 'OrderPlacedByEmail',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderType',
      backendName: 'OrderType',
      type: 'string',
      placeholder: "Enter Order Type",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'OrderDate',
      backendName: 'OrderDate',
      type: 'date',
      placeholder: "Enter OrderDate",
      required: true,
      isEditable: true,
      // validationFunction: yup.string().required()
      validationFunction: ""
    },
    {
      displayName: 'Requested Delivery Date',
      backendName: 'RequestedDeliveryDate',
      type: 'date',
      placeholder: "Enter Requested Delivery Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Shipping Preference',
      backendName: 'ShippingPreference',
      type: 'option',
      placeholder: "Select Shipping Preference",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required()
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountID',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: yup.number().required("This is a required field")
    },
    {
      displayName: 'Ship to Account',
      backendName: 'ShipToAccountName',
      type: 'option',
      placeholder: "Enter Ship to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactName',
      type: 'option',
      placeholder: "Enter Ship to Contact Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Ship to Contact Name',
      backendName: 'ShipToContactID',
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'ShipAddressLine1',
      type: 'string',
      placeholder: "Enter Ship to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'PO Number',
      backendName: 'PONumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Shipping Cost',
      backendName: 'ShippingCost',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'ShipAddressLine2',
      type: 'string',
      placeholder: "Enter Ship to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'ShipCity',
      type: 'string',
      placeholder: "Enter Ship to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'ShipState',
      type: 'string',
      placeholder: "Enter Ship to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'ShipZip',
      type: 'string',
      placeholder: "Enter Ship to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'ShipPhone',
      type: 'string',
      placeholder: "Enter Ship to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'ShipFax',
      type: 'string',
      placeholder: "Enter Ship to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountID',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Bill to Account Name',
      backendName: 'BillToAccountName',
      type: 'option',
      placeholder: "Enter Bill to Account Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContact',
      validationFunction: ""
    },
    {
      displayName: 'Accounts Payable Contact',
      backendName: 'AccountsPayableContactID',
      validationFunction: ""
    },
    {
      displayName: 'Bill to Contact Name',
      backendName: 'BillToContactName',
      type: 'option',
      placeholder: "Enter Bill to Contact Name",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 1',
      backendName: 'BillAddressLine1',
      type: 'string',
      placeholder: "Enter Bill to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Address Line 2',
      backendName: 'BillAddressLine2',
      type: 'string',
      placeholder: "Enter Bill to Address",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'BillCity',
      type: 'string',
      placeholder: "Enter Bill to City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'BillState',
      type: 'string',
      placeholder: "Enter Bill to State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'BillZip',
      type: 'string',
      placeholder: "Enter Bill to Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'BillPhone',
      type: 'string',
      placeholder: "Enter Bill to Phone",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'BillFax',
      type: 'string',
      placeholder: "Enter Bill to Fax",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Physician Name',
      backendName: 'PhysicianName',
      type: 'string',
      placeholder: "Enter Physician Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test(
        'len',
        "Must be less than 255 characters", // error message
        (val) => !val || val.length < 255 // validation function
      )
    },
    {
      displayName: 'Patient First Name',
      backendName: 'PatientFirstName',
      type: 'string',
      placeholder: "Enter Physician First Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().min(0).max(3, 'Please enter first three letters only'),
      // validateSchema: ""
    },
    {
      displayName: 'Patient Last Name',
      backendName: 'PatientLastName',
      type: 'string',
      placeholder: "Enter Physician Last Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().min(0).max(3, 'Please enter first three letters only'),
      // validateSchema: ""
    },
    {
      displayName: 'CaseID',
      backendName: 'CaseID',
      type: 'option',
      placeholder: "Enter Case ID",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Date Of Application',
      backendName: 'DateOfApplication',
      type: 'date',
      placeholder: "Date Of Application",
      required: true,
      isEditable: true,
      // validationFunction: yup.date().required()
      validationFunction: ""
    },
    {
      displayName: 'Application Number',
      backendName: 'ApplicationNumber',
      type: 'string',
      placeholder: "Enter Application Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerID',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerName',
      type: 'option',
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Number Of Products',
      backendName: 'NumberOfProducts',
      type: 'number',
      placeholder: "Enter Number Of Products",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Order Total',
      backendName: 'OrderTotal',
      type: 'number',
      placeholder: "Enter Order Total",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Tracking Number',
      backendName: 'TrackingNumber',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved By',
      backendName: 'ApprovedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Approved Date',
      backendName: 'ApprovedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected By',
      backendName: 'RejectedBy',
      type: 'string',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Rejected Date',
      backendName: 'RejectedDate',
      type: 'date',
      placeholder: "",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Reject Remarks',
      backendName: 'RejectRemarks',
      validationFunction: ""
    }
  ]
  static IVRFormAdd = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      placeholder: "Select Account",
      required: true,
      validationFunction: yup.number().required("This is a required field")
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUserID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor User',
      backendName: 'DistributorUsername',
      validationFunction: ""
    },
    {
      displayName: 'Submitted By',
      backendName: 'SubmittedBy',
      type: 'string',
      placeholder: "Enter Submitted By",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: 'Submitted By',
      backendName: 'SubmittedByUserID',
    },
    {
      displayName: "Submission Date",
      backendName: "SubmissionDate",
      type: "date",
      placeholder: "Enter Submission Date",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Place of Service",
      backendName: "PlaceOfService",
      type: "string",
      placeholder: "Enter Place of Service",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field")
    },
    {
      displayName: 'Contact Name',
      backendName: 'AccountContactName',
      type: 'string',
      placeholder: "Select Contact Name",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: "Physician Name",
      backendName: "PhysicianName",
      type: "string",
      placeholder: "Select Physician Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test(
        "len", // test name (unique identifier)
        "Must be less than 50 characters", // error message
        (val) => !val || val.length < 50 // validation function
      )
    },
    {
      displayName: "Address Line 1",
      backendName: "AccountAddressLine1",
      type: "string",
      placeholder: "Enter Address Line 1",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: "Address Line 2",
      backendName: "AccountAddressLine2",
      type: "string",
      placeholder: "Enter Address Line 2",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'City',
      backendName: 'AccountCity',
      type: 'string',
      placeholder: "Enter City",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'State',
      backendName: 'AccountState',
      type: 'string',
      placeholder: "Enter State",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Zip',
      backendName: 'AccountZip',
      type: 'string',
      placeholder: "Enter Zip",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'AccountPhone',
      type: 'string',
      placeholder: "Enter Ship to Phone",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'Fax',
      backendName: 'AccountFax',
      type: 'string',
      placeholder: "Enter Fax",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: "Medicare Admin Contractor",
      backendName: "MedicareAdminContractor",
      type: "string",
      placeholder: "Enter Medicare Admin Contractor",
      required: true,
      isEditable: false,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 60 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 60;
      })
    },
    {
      displayName: 'NPI',
      backendName: 'NPI',
      type: 'string',
      placeholder: "Enter NPI",
      required: true,
      isEditable: false,
      validationFunction: ""
    },
    {
      displayName: 'TIN',
      backendName: 'TIN',
      type: 'string',
      placeholder: "Enter TIN",
      required: true,
      isEditable: false,
      validationFunction: yup.string().required("This is a required field")
    },
    {
      displayName: 'PTAN',
      backendName: 'PTAN',
      type: 'string',
      placeholder: "Enter PTAN",
      required: true,
      isEditable: false,
      validationFunction: yup.string().required("This is a required field")
    },
    {
      displayName: 'Patient First Name',
      backendName: 'PatientFirstName',
      type: 'string',
      placeholder: "Enter Physician First Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 30 characters', val => { return val?.length < 30 || val === null })
    },
    {
      displayName: 'Patient Last Name',
      backendName: 'PatientLastName',
      type: 'string',
      placeholder: "Enter Physician Last Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: 'Patient DOB',
      backendName: 'PatientDOB',
      type: 'date',
      placeholder: "Enter Patient DOB",
      required: true,
      isEditable: true,
      validationFunction: yup.date().required("DOB is required")
    },
    {
      displayName: "Patient Phone",
      backendName: "PatientPhone",
      type: "string",
      placeholder: "Enter Patient Phone",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 20 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 20;
      })
    },
    {
      displayName: "Patient Email",
      backendName: "PatientEmail",
      type: "string",
      placeholder: "Enter Patient Email",
      required: true,
      isEditable: true,
      validationFunction: yup.string().email("Invalid email format").nullable().test('len', 'Must be less than 100 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 100;
      })
    },
    {
      displayName: "Patient Address Line 1",
      backendName: "PatientAddressLine1",
      type: "string",
      placeholder: "Enter Patient Address Line 1",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient Address Line 2",
      backendName: "PatientAddressLine2",
      type: "string",
      placeholder: "Enter Patient Address Line 2",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient City",
      backendName: "PatientCity",
      type: "string",
      placeholder: "Enter Patient City",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient State",
      backendName: "PatientState",
      type: "string",
      placeholder: "Enter Patient State",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient Zip",
      backendName: "PatientZip",
      type: "string",
      placeholder: "Enter Patient Zip",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Okay to Contact Patient",
      backendName: "OkayToContactPatient",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient Demo Sheet",
      backendName: "PatientDemoSheet",
      type: "file",
      placeholder: "Upload Patient Demo Sheet",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Primary Insurance",
      backendName: "PrimaryInsuranceName",
      type: "string",
      placeholder: "Enter Primary Insurance",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })
    },
    {
      displayName: "Policy Number",
      backendName: "PolicyNumber",
      type: "string",
      placeholder: "Enter Policy Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Subscriber Name",
      backendName: "SubscriberName",
      type: "string",
      placeholder: "Enter Subscriber Name",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 50 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 50;
      })
    },
    {
      displayName: "Subscriber DOB",
      backendName: "SubscriberDOB",
      type: "date",
      placeholder: "Enter Subscriber DOB",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Type of Plan",
      backendName: "TypeOfPlan",
      type: "string",
      placeholder: "Enter Type of Plan",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 20 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 20;
      })
    },
    {
      displayName: "Insurance Phone Number",
      backendName: "InsurancePhoneNumber",
      type: "string",
      placeholder: "Enter Insurance Phone Number",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 20 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 20;
      })
    },
    {
      displayName: "Provider in Network",
      backendName: "ProviderInNetwork",
      type: "option",
      placeholder: "Select Provider in Network",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Primary Insurance Card",
      backendName: "PrimaryInsuranceCard",
      type: "file",
      placeholder: "Primary Insurance Card",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Secondary Insurance",
      backendName: "SecondaryInsuranceName",
      type: "string",
      placeholder: "Enter Secondary Insurance",
      required: false,
      isEditable: true,
      validationFunction:  yup.string().nullable().test('len', 'Must be less than 100 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 100;
      })
    },
    {
      displayName: "Secondary Policy Number",
      backendName: "SecondaryPolicyNumber",
      type: "string",
      placeholder: "Enter Secondary Policy Number",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 60 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 60;
      })
    },
    {
      displayName: "Secondary Subscriber Name",
      backendName: "SecondarySubscriberName",
      type: "string",
      placeholder: "Enter Secondary Subscriber Name",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 50 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 50;
      })
    },
    {
      displayName: "Secondary Subscriber DOB",
      backendName: "SecondarySubscriberDOB",
      type: "date",
      placeholder: "Enter Secondary Subscriber DOB",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Secondary Type of Plan",
      backendName: "SecondaryTypeOfPlan",
      type: "string",
      placeholder: "Enter Secondary Type of Plan",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 100 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 100;
      })
    },
    {
      displayName: "Secondary Insurance Phone Number",
      backendName: "SecondaryInsurancePhoneNumber",
      type: "string",
      placeholder: "Enter Secondary Insurance Phone Number",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Secondary Provider in Network",
      backendName: "SecondaryProviderInNetwork",
      type: "option",
      placeholder: "Select Secondary Provider in Network",
      required: false,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Secondary Insurance Card",
      backendName: "SecondaryInsuranceCard",
      type: "file",
      placeholder: "Secondary Insurance Card",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Wound Type",
      backendName: "WoundType",
      type: "string",
      placeholder: "Enter Wound Type",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 255 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 255;
      })

    },
    {
      displayName: "Wound Size",
      backendName: "WoundSize",
      type: "string",
      placeholder: "Enter Wound Size",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Application CPT",
      backendName: "ApplicationCPT",
      type: "string",
      placeholder: "Enter Application CPT",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "ICD-10 Diagnosis Code",
      backendName: "ICD10",
      type: "string",
      placeholder: "Enter ICD10",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 30 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 30;
      })
    },
    {
      displayName: "Patient Clinical Records",
      backendName: "PatientClinicalRecords",
      type: "file",
      placeholder: "Upload Patient Clinical Records",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Patient Residing in SNF",
      backendName: "PatientResidingInSNF",
      type: "string",
      placeholder: "",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "SurgicalGlobalPeriod",
      backendName: "SurgicalGlobalPeriod",
      type: "string",
      placeholder: "",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "PatientInHospice",
      backendName: "PatientInHospice",
      type: "string",
      placeholder: "",
      required: false,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "CPT Code",
      backendName: "CPTCode",
      type: "string",
      placeholder: "Enter CPT Code",
      required: true,
      isEditable: true,
      validationFunction: yup.string().nullable().test('len', 'Must be less than 20 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 20;
      })
    },
    {
      displayName: "Date of Procedure",
      backendName: "DateOfProcedure",
      type: "date",
      placeholder: "Enter Date of Procedure",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "PatientDemoSheetsFilename",
      backendName: "PatientDemoSheetsFilename",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "PatientInsuranceCardFilename",
      backendName: "PatientInsuranceCardFilename",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "SecondaryInsuranceCardFilename",
      backendName: "SecondaryInsuranceCardFilename",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "PatientClinicalRecordFilename",
      backendName: "PatientClinicalRecordFilename",
      type: "string",
      placeholder: "",
      required: true,
      isEditable: true,
      validationFunction: ""
    },
    {
      displayName: "Signature",
      backendName: "Signature",
      validationFunction: yup.string().required("This is a required field").test('len', 'Must be less than 100 characters', val => {
        if (val === null || val === undefined || val === '') return true; // skip if empty
        return val.length < 100;
      })
    },
  ]
  static EditAccountProductLog = [
    {
      displayName: 'ID',
      backendName: 'ID',
      type: 'number',
      placeholder: "",
      required: true,
      isEditable: false
    },
    {
      displayName: 'ApplicationDate',
      backendName: 'ApplicationDate',
      validationFunction: ""
    },
    {
      displayName: 'ApplicationNumber',
      backendName: 'ApplicationNumber',
      validationFunction: ""
    },
    {
      displayName: 'TissueTrackingFile',
      backendName: 'TissueTrackingFile',
      validationFunction: "",
    },
    {
      displayName: 'TissueTrackingFileName',
      backendName: 'TissueTrackingFileName',
      validationFunction: "",
    },
    {
      displayName: 'InvoiceID',
      backendName: 'InvoiceID',
      validationFunction: ""
    },
    {
      displayName: 'OrderID',
      backendName: 'OrderID',
      validationFunction: ""
    },
    {
      displayName: 'OrderType',
      backendName: 'OrderType',
      validationFunction: ""
    },
    {
      displayName: 'Price',
      backendName: 'Price',
      validationFunction: ""
    },
    {
      displayName: 'ProductCode',
      backendName: 'ProductCode',
      validationFunction: ""
    },
    {
      displayName: 'ProductName',
      backendName: 'ProductName',
      validationFunction: ""
    },
    {
      displayName: 'TissueID',
      backendName: 'TissueID',
      validationFunction: ""
    },
    {
      displayName: 'PatientFirstName',
      backendName: 'PatientFirstName',
      validationFunction: yup.string().max(3, 'Please enter first three letters only').required("This is a required field"),
    },
    {
      displayName: 'PatientLastName',
      backendName: 'PatientLastName',
      validationFunction: yup.string().max(3, 'Please enter first three letters only').required("This is a required field"),
    },
    {
      displayName: 'Patient',
      backendName: 'Patient',
      validationFunction: ""
    },
    {
      displayName: 'TissueTrackingFileBlobName',
      backendName: 'TissueTrackingFileBlobName',
      validationFunction: ""
    },
    {
      displayName: 'ClaimNumber',
      backendName: 'ClaimNumber',
      validationFunction: ""
    }
  ]
  static ContactUserDetails = [
    {
      displayName: 'ID',
      backendName: 'ID',
      validationFunction: ""
    },
    {
      displayName: 'UserID',
      backendName: 'UserID',
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountName',
      validationFunction: ""
    },
    {
      displayName: 'Prefix',
      backendName: 'Prefix',
      validationFunction: ""
    },
    {
      displayName: 'FirstName',
      backendName: 'FirstName',
      validationFunction: ""
    },
    {
      displayName: 'LastName',
      backendName: 'LastName',
      validationFunction: ""
    },
    {
      displayName: 'Email',
      backendName: 'Email',
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      validationFunction: ""
    },
  ]
  static AccountUserDetails = [
    {
      displayName: 'ID',
      backendName: 'ID',
      validationFunction: ""
    },
    {
      displayName: 'UserID',
      backendName: 'UserID',
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountID',
      validationFunction: ""
    },
    {
      displayName: 'Account',
      backendName: 'AccountName',
      validationFunction: ""
    },
    {
      displayName: 'Prefix',
      backendName: 'Prefix',
      validationFunction: ""
    },
    {
      displayName: 'FirstName',
      backendName: 'FirstName',
      validationFunction: ""
    },
    {
      displayName: 'LastName',
      backendName: 'LastName',
      validationFunction: ""
    },
    {
      displayName: 'Email',
      backendName: 'Email',
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      validationFunction: ""
    },
    {
      displayName: 'RoleType',
      backendName: 'RoleType',
      validationFunction: ""
    },
    {
      displayName: 'AccountContactType',
      backendName: 'AccountContactType',
      validationFunction: ""
    },
    {
      displayName: 'ProviderNPI',
      backendName: 'ProviderNPI',
      validationFunction: ""
    },
    {
      displayName: '',
      backendName: 'TVUser',
      validationFunction: ""
    }
  ]
  static DistributorUserDetails = [
    {
      displayName: 'ID',
      backendName: 'ID',
      validationFunction: ""
    },
    {
      displayName: 'UserID',
      backendName: 'UserID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      validationFunction: ""
    },
    {
      displayName: 'Prefix',
      backendName: 'Prefix',
      validationFunction: ""
    },
    {
      displayName: 'FirstName',
      backendName: 'FirstName',
      validationFunction: ""
    },
    {
      displayName: 'LastName',
      backendName: 'LastName',
      validationFunction: ""
    },
    {
      displayName: 'Email',
      backendName: 'Email',
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      validationFunction: ""
    },
  ]
  static ManufacturerUserDetails = [
    {
      displayName: 'ID',
      backendName: 'ID',
      validationFunction: ""
    },
    {
      displayName: 'UserID',
      backendName: 'UserID',
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerID',
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerName',
      validationFunction: ""
    },
    {
      displayName: 'Prefix',
      backendName: 'Prefix',
      validationFunction: ""
    },
    {
      displayName: 'FirstName',
      backendName: 'FirstName',
      validationFunction: ""
    },
    {
      displayName: 'LastName',
      backendName: 'LastName',
      validationFunction: ""
    },
    {
      displayName: 'Email',
      backendName: 'Email',
      validationFunction: ""
    },
    {
      displayName: 'Phone',
      backendName: 'Phone',
      validationFunction: ""
    },
  ]
  static InvoiceHomeOrderProducts = [
    {
      displayName: 'ID',
      backendName: 'ID',
      validationFunction: ""
    },
    {
      displayName: 'InvoiceID',
      backendName: 'InvoiceID',
      validationFunction: ""
    },
    {
      displayName: 'Tissue ID',
      backendName: 'TissueID',
      validationFunction: yup.string().required("This is a required field"),
      // validationFunction: "",
    },
    {
      displayName: 'Product Code',
      backendName: 'ProductCode',
      validationFunction: yup.string().required("This is a required field"),
      // validationFunction: "",
    },
    {
      displayName: 'Cost',
      backendName: 'Price',
      validationFunction: yup.number().required("This is a required field"),
      // validationFunction: "",
    },
  ]
  static NewCommissionContract = [
    {
      displayName: 'ID',
      backendName: 'ID',
      isEditable: false
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      validationFunction: ""
    },
    {
      displayName: 'Start Date',
      backendName: 'StartDate',
      validationFunction: ""
    },
    {
      displayName: 'End Date',
      backendName: 'EndDate',
      validationFunction: ""
    },
    {
      displayName: 'Is Ended',
      backendName: 'IsEnded',
      validationFunction: ""
    },
    {
      displayName: 'Created By',
      backendName: 'CreatedBy',
      validationFunction: ""
    },
    {
      displayName: 'Contract Notes',
      backendName: 'ContractNotes',
      validationFunction: ""
    },
    {
      displayName: 'Revision',
      backendName: 'Revision',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract',
      backendName: 'UploadContract',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract File Name',
      backendName: 'UploadContractFilename',
      validationFunction: ""
    },
    {
      displayName: 'AzureBlobName',
      backendName: 'AzureBlobName',
      validationFunction: ""
    },
  ]
  static CommissionsHomeForm = [
    {
      displayName: 'Commissionable Sale',
      backendName: 'CommissionableSale',
      validationFunction: ""
    },
    {
      displayName: 'Commission Applied till Date',
      backendName: 'CommissionApplied',
      validationFunction: ""
    },
    {
      displayName: 'Remaining Balance as of Today',
      backendName: 'RemainingBalance',
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer Commission % for AS',
      backendName: 'ManufacturerCommissionAS',
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer Commission Receivable',
      backendName: 'ManufacturerCommissionReceivable',
      validationFunction: ""
    },
    {
      displayName: 'Commission Received till Date',
      backendName: 'CommissionReceived',
      validationFunction: ""
    },
    {
      displayName: 'Total Commission Payable',
      backendName: 'TotalCommissionPayableDistributor',
      validationFunction: ""
    },
    {
      displayName: 'Commission Due till Date',
      backendName: 'CommissionDueDistributor',
      validationFunction: ""
    },
    {
      displayName: 'Remaining Commission Due',
      backendName: 'RemainingCommissionDueDistributor',
      validationFunction: ""
    },
    {
      displayName: 'Total Commission Payable',
      backendName: 'TotalCommissionPayableASD',
      validationFunction: ""
    },
    {
      displayName: 'Commission Due till Date',
      backendName: 'CommissionDueASD',
      validationFunction: ""
    },
    {
      displayName: 'Remaining Commission Due',
      backendName: 'RemainingCommissionDueASD',
      validationFunction: ""
    },
    {
      displayName: 'Total Profit Receivable',
      backendName: 'TotalProfitReceivable',
      validationFunction: ""
    },
    {
      displayName: 'Total Profit till Date',
      backendName: 'TotalProfit',
      validationFunction: ""
    },
    {
      displayName: 'Remaining Profit',
      backendName: 'RemainingProfit',
      validationFunction: ""
    },
  ]
  static ApplyCommissionForm = [
    {
      displayName: 'Invoice',
      backendName: 'InvoiceNumber',
      validationFunction: ""
    },
    {
      displayName: 'Date Applied',
      backendName: 'DateApplied',
      validationFunction: yup.date().required("This is a required field")
    },
    {
      displayName: 'Statement Month',
      backendName: 'StatementMonth',
      validationFunction: ""
    },
    {
      displayName: 'Invoice Total',
      backendName: 'InvoiceTotal',
      validationFunction: ""
    },
    {
      displayName: 'Total Balance',
      backendName: 'TotalBalance',
      validationFunction: ""
    },
    {
      displayName: 'Total Received',
      backendName: 'TotalReceived',
      validationFunction: yup.number().required("This is a required field")
    },
    {
      displayName: 'AS Comm. %',
      backendName: 'ASCommissionPercent',
      validationFunction: ""
    },
    {
      displayName: 'Comm. Received',
      backendName: 'CommissionReceived',
      validationFunction: ""
    },
    {
      displayName: 'Shipping Cost',
      backendName: 'ShippingCost',
      validationFunction: ""
    },
    {
      displayName: 'ShippingCostPaidAmount',
      backendName: 'ShippingCostPaidAmount',
      validationFunction: ""
    },
    {
      displayName: 'Shipping Cost Assigned To',
      backendName: 'ShippingCostAssignedTo',
      validationFunction: ""
    },
  ]
  static NewManufacturerContract = [
    {
      displayName: 'ID',
      backendName: 'ID',
      isEditable: false
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerID',
      validationFunction: ""
    },
    {
      displayName: 'Manufacturer',
      backendName: 'ManufacturerName',
      validationFunction: ""
    },
    {
      displayName: 'Start Date',
      backendName: 'StartDate',
      validationFunction: ""
    },
    {
      displayName: 'End Date',
      backendName: 'EndDate',
      validationFunction: ""
    },
    {
      displayName: 'Is Ended',
      backendName: 'IsEnded',
      validationFunction: ""
    },
    {
      displayName: 'Created By',
      backendName: 'CreatedBy',
      validationFunction: ""
    },
    {
      displayName: 'Contract Notes',
      backendName: 'ContractNotes',
      validationFunction: ""
    },
    {
      displayName: 'Revision',
      backendName: 'Revision',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract',
      backendName: 'UploadContract',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract File Name',
      backendName: 'UploadContractFilename',
      validationFunction: ""
    },
    {
      displayName: 'TierOnePercentage',
      backendName: 'TierOnePercentage',
      validationFunction: ""
    },
    {
      displayName: 'TierTwoStart',
      backendName: 'TierTwoStart',
      validationFunction: ""
    },
    {
      displayName: 'TierTwoPercentage',
      backendName: 'TierTwoPercentage',
      validationFunction: ""
    },
    {
      displayName: 'TierThreeStart',
      backendName: 'TierThreeStart',
      validationFunction: ""
    },
    {
      displayName: 'TierThreePercentage',
      backendName: 'TierThreePercentage',
      validationFunction: ""
    },
  ]
  static NewDistributorReferralContract = [
    {
      displayName: 'ID',
      backendName: 'ID',
      isEditable: false
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorID',
      validationFunction: ""
    },
    {
      displayName: 'Distributor',
      backendName: 'DistributorName',
      validationFunction: ""
    },
    {
      displayName: 'Start Date',
      backendName: 'StartDate',
      validationFunction: ""
    },
    {
      displayName: 'End Date',
      backendName: 'EndDate',
      validationFunction: ""
    },
    {
      displayName: 'Is Ended',
      backendName: 'IsEnded',
      validationFunction: ""
    },
    {
      displayName: 'Created By',
      backendName: 'CreatedBy',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract',
      backendName: 'UploadContract',
      validationFunction: ""
    },
    {
      displayName: 'Upload Contract File Name',
      backendName: 'UploadContractFilename',
      validationFunction: ""
    },
    {
      displayName: 'Referee Distributor',
      backendName: 'RefereeDistributorID',
      validationFunction: ""
    },
    {
      displayName: 'Referee Distributor',
      backendName: 'RefereeDistributorName',
      validationFunction: ""
    },
    {
      displayName: 'ReferralCommissionPercentage',
      backendName: 'ReferralCommissionPercentage',
      validationFunction: ""
    },
  ]
  static NewCommissionStatement = [
    {
      displayName: 'ID',
      backendName: 'ID',
      isEditable: false
    },
    {
      displayName: 'Statement Start Date',
      backendName: 'StatementStartDate',
      validationFunction: ""
    },
    {
      displayName: 'Statement End Date',
      backendName: 'StatementEndDate',
      validationFunction: ""
    },
    {
      displayName: 'Payout Date',
      backendName: 'PayoutDate',
      validationFunction: ""
    },
    {
      displayName: 'Statement Month',
      backendName: 'StatementMonthYear',
      validationFunction: ""
    },
  ]
} 
